import { Mic, MicOff } from 'lucide-react';

const TEXT = {
  listening: 'Microfono in ascolto',
  suspended: 'Tocca lo schermo per attivare il microfono',
  denied: 'Permesso microfono negato: abilitalo dalle impostazioni del browser',
  error: 'Microfono non disponibile su questo dispositivo',
};

export const MicStatus = ({ status, needed }) => {
  const on = status === 'listening';
  const text = needed ? TEXT[status] || 'Attivazione microfono…' : 'Microfono spento · si accende con una scala o un round di intervalli';
  const Icon = on ? Mic : MicOff;
  return (
    <span data-testid="drone-mic-status" className={`inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] ${on ? 'text-emerald-400' : needed ? 'text-pink-300' : 'text-white/40'}`}>
      <Icon className="w-3.5 h-3.5" /> {text}
    </span>
  );
};
